<template>
    <div class="mtp-container">
        <MagRouterView nested />
    </div>
</template>

<script setup lang="ts">
import MagRouterView from "@/components/MagRouterView.vue";
import {
    createMemoryHistory,
    createRouter,
    routeLocationKey,
    routerKey,
    routerViewLocationKey,
} from "vue-router";
import { authGuard, routes } from "@/router";
import { computed, provide, watchEffect } from "vue";
import { toReactive } from "@vueuse/core";
import { useFluent } from "fluent-vue";
import { providePageMetadata } from "@/composables/page-metadata";
import { TileControls, TilePageProps } from "@/store/tile-store";

const { $t } = useFluent();

const pageMetadata = providePageMetadata();

const props = defineProps<
    TilePageProps & {
        controls: TileControls;
    }
>();

const history = createMemoryHistory();

const router = createRouter({
    history,
    routes: routes,
});

router.beforeResolve(authGuard);

provide("$router", router);
provide(routerKey, router);
provide(routeLocationKey, toReactive(router.currentRoute));
provide(routerViewLocationKey, router.currentRoute);

const buttonsLeft = computed(() => {
    return [
        {
            icon: "caret-left",
            onClick: () => router.back(),
        },
    ];
});

const buttonsRight = computed(() => {
    return [
        {
            icon: "arrows-out-simple",
            title: $t("showInPage"),
            onClick: expand,
        },
    ];
});

watchEffect(() => {
    const meta = pageMetadata.value;

    if (!meta) {
        return;
    }

    props.controls.setTitle(meta.title);
    props.controls.setIcon(meta.icon ?? undefined);
});

await router.push(props.initialPath);
await router.isReady();
</script>

<style scoped lang="scss">
.mtp-container {
    min-height: 100%;
    background: var(--bg);
}
</style>
